function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 8.01C0 3.585 3.58 0 8 0s8 3.585 8 8.01-3.58 8.01-8 8.01-8-3.585-8-8.01z",
  fill: "#F2F2F2"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.71 2.67a.858.858 0 00-.6.247L8.921 4.11l2.972 2.985 1.19-1.18a.843.843 0 000-1.204l-1.778-1.793a.855.855 0 00-.595-.247zM8.523 4.508L3.98 9.067l1.436.157.1 1.287 1.28.096.162 1.439 4.543-4.559-2.978-2.979zM3.649 9.59l-.981 3.76 3.757-1.006-.134-1.214-1.296-.096-.1-1.304",
  fill: "#9A99A2"
});

function SvgEditCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgEditCircle;